/**
 * v0.9.10b — ground-height wording (📍 label + summary). Under ELEV_LOWLAND_M no number is shown: GLO-90 is a
 * ~90-m surface model, several metres off and in towns the top of the buildings, so 2 m vs 6 m means nothing.
 */
export const ELEV_LOWLAND_M = 10;
export const LOWLAND_TEXT = "ที่ราบลุ่ม ใกล้ระดับน้ำทะเล";
/** "สูงจากระดับน้ำทะเลประมาณ N ม." (whole metres, ≥ 10 m) · under 10 m → "ที่ราบลุ่ม ใกล้ระดับน้ำทะเล" */
export function elevationText(m: number): string {
  const n = Math.round(m);
  return n < ELEV_LOWLAND_M ? LOWLAND_TEXT : `สูงจากระดับน้ำทะเลประมาณ ${n} ม.`;
}
